var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fn-ui-nav-bar"},[_c('div',{staticClass:"fn-ui-nav-bar__mobile",on:{"click":_vm.toggleMobileMenu}},[_c('icon',{attrs:{"icon":"bars","size":"2x"}})],1),_c('div',{staticClass:"fn-ui-nav-bar__title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }